import { Form } from 'react-bootstrap'

const smLabel = {
  fontSize: '9px',
  lineHeight: '12px',
  color: '#828282'
}

const index = ({
  label,
  type = 'text',
  placeholder = '',
  name,
  value,
  handleChange,
  handleKeyPress = () => {},
  handleBlur,
  touched,
  errors,
  required = false,
  step = 'any',
  disabled = false,
  col,
  bold = 'bold',
  labelsm,
  as = 'input',
  styles = undefined,
  helperText
}) => {
  return (
    <Form.Group
      className={`mb-3 col-12 col-md-${col} col-lg-${col}`}
      controlId={name}
    >
      <Form.Label
        className={`text-muted text-uppercase cursor-pointer fw-${
          bold ? 'bold' : 'normal'
        }`}
        style={{ fontSize: '13px', letterSpacing: '0.5px' }}
        role="button"
        tabIndex={0}
      >
        {label}
        {labelsm && <small style={smLabel}>{labelsm}</small>}
        {required === true && <sup style={{ color: 'red' }}>*</sup>}
      </Form.Label>
      <Form.Control
        type={type}
        as={as}
        placeholder={placeholder}
        name={name}
        required={required}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyPress}
        step={step}
        isInvalid={touched?.[name] && !!errors?.[name]}
        disabled={disabled}
        data-date-format="dd-mm-yyyy"
        autoComplete="off"
        style={styles}
      />
      {helperText && (
        <Form.Text
          className="text-muted"
          style={{ fontSize: '11px', display: 'block', marginTop: '4px' }}
        >
          {helperText}
        </Form.Text>
      )}
      {touched?.[name] && !!errors?.[name] && (
        <Form.Control.Feedback type="invalid">
          {errors?.[name]}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  )
}

export default index
